// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'row-insert';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M17.438 10.686H.563m16.875-3.375H.563M9 .561v6.75m0 3.375v6.75m2.813-14.062L9.001.56 6.188 3.374m5.625 11.249-2.812 2.813-2.813-2.813'
  />
);

export const viewBox = '0 0 18 18';
